export default "__VITE_ASSET__f03bb01a__"